import { appPaths } from "../../Routes";
import RatioMetricCard from "../RatioMetricCard";
import SectionTitle from "../SectionTitle";

export type EmissionFactorsSectionProps = {
    activityDataPointsTotalCount: number;
    dataSourcesTotalCount: number;
    activityDataPointsWithNoEmissionsFactorCount: number;
    dataSourcesWithNoEmissionsFactorCount: number;
};

const EmissionFactorsSection = ({
    dataSourcesTotalCount,
}: EmissionFactorsSectionProps) => {
    return (
        <div className="space-y-6">
            <SectionTitle title="Data Sources" />
            <div className="md:grid grid-cols-2 gap-6 space-y-6 md:space-y-0">
                <RatioMetricCard
                    title="Automated data sources"
                    portion={
                        Math.round(0.6 * dataSourcesTotalCount)
                    }
                    total={dataSourcesTotalCount}
                    href={appPaths.dataSources}
                />
                <RatioMetricCard
                    title="Verified sources"
                    portion={
                        Math.round(0.3 * dataSourcesTotalCount)
                    }
                    total={dataSourcesTotalCount}
                    href={appPaths.dataSources}
                />
            </div>
        </div>
    );
};

export default EmissionFactorsSection;
